/**
 * created by wang lei
 * 统计 筛选输入框
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import {Input} from "antd";

export default class Sta_Input extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {
            value,
            onChange,
            config={},
            labelCode,
            size,
            disabled,
            id,
            placeholder,
        } = this.props;
        const {style={}} = config;
        return (
            <div>
                <Input
                    value={value}
                    onChange={(v)=>{
                        onChange({labelCode,val:v.target.value})
                    }}
                    style={{...style}}
                    placeholder={placeholder}
                    size={size}
                    disabled={disabled}
                    id={id}
                />
            </div>
        )
    }

}